var buttonOpenPopup_ju = document.querySelector('.template-product .popup__button_ju');
var popup_ju = document.querySelector('.template-product .popup_ju .popup-container_ju');
var overlay_ju = document.querySelector('.template-product .popup-overlay_ju');
var buttonClosePopup_ju = document.querySelector('.template-product .popup-container__btn-close_ju');

buttonOpenPopup_ju.addEventListener('click', function(){
    popup_ju.classList.add('active3');
    overlay_ju.classList.add('active3');
})

overlay_ju.addEventListener('click', function(){
    popup_ju.classList.remove('active3');
    overlay_ju.classList.remove('active3');
})

buttonClosePopup_ju.addEventListener('click', function(){
    popup_ju.classList.remove('active3');
    overlay_ju.classList.remove('active3');
})